<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>QUEST</h2>
        <p>
          축적된 노하우와 기술력으로 최적의 솔루션과 서비스를 제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont">
      <div id="overview" class="subCon inner_box">
        <section class="platform1">
          <h3 class="con_tit">About Conversion</h3>

          <div class="img">
            <v-img
              src="@/assets/img/conversion/about/about_img1.svg"
              alt=""
              style="
                border-radius: 8px;
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                  0 6px 20px 0 rgba(0, 0, 0, 0.19);
                margin: 0 auto;
                max-width: 75%;
                align-items: center;
              "
            />
          </div>

          <div class="con">
            <p style="font-size: 20px">
              Conversion 솔루션은 크게 AS-IS 시스템 분석 솔루션, <br />서버
              컨버전 솔루션, 데이터베이스 교체 시 컨버전 솔루션, <br />그리고
              프로그램 언어 변환 컨버전 솔루션으로 이루어져 있습니다.
            </p>
            <p style="font-size: 20px">
              Conversion 솔루션의 프로세스 과정은 <br />자원 수집, 자원 분석,
              전환 룰 추출 및 등록 <br />그리고 전환 검증 단계로 이루어져
              있습니다.
            </p>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
